import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import React, { useState, useEffect, useContext } from 'react';
import { Checkbox } from 'antd';
import styled from 'styled-components';
import Divider from '../Divider';
import translations from '../translations';
import { TmsUIContext } from '../../TmsUIProvider';
var AntCheckboxGroup = styled(Checkbox.Group)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.ant-checkbox-group {\n    display: ", ";\n    flex-direction: ", ";\n\n    & > label.ant-checkbox-group-item {\n      margin: ", ";\n\n      &:first-child {\n        margin-top: 0;\n      }\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n"])), function (props) {
  return props.direction === 'vertical' && 'flex';
}, function (props) {
  return props.direction === 'vertical' && 'column';
}, function (props) {
  return props.direction === 'vertical' && '0.25rem 0';
});
var CheckboxGroupContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));

/**
 * Checkbox Group component
 * @param {Object} props
 * @param {String[]} props.value
 * @param {("vertical" | "horizontal")} props.direction
 * @param {Boolean} props.disabled
 * @param {String} props.name
 * @param {Object[]} props.options
 * @param {String} props.options.label
 * @param {String} props.options.value
 * @param {String[]} props.defaultValue
 * @param {Function} props.onChange
 */
function CheckboxGroup(_ref) {
  var value = _ref.value,
      dataTestId = _ref['data-testid'],
      defaultValue = _ref.defaultValue,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'vertical' : _ref$direction,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function (e) {
    return e;
  } : _ref$onChange,
      _ref$useCheckAll = _ref.useCheckAll,
      useCheckAll = _ref$useCheckAll === void 0 ? true : _ref$useCheckAll,
      children = _ref.children;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      localValue = _useState2[0],
      setLocalValue = _useState2[1];

  var _useContext = useContext(TmsUIContext),
      translate = _useContext.translate,
      setDefaultTranslations = _useContext.setDefaultTranslations;

  var isAllChecked = localValue.length >= options.length;

  var handleChange = function handleChange(newValue) {
    if (!Array.isArray(value)) {
      setLocalValue(newValue);
    }

    onChange(newValue);
  };

  useEffect(function () {
    if (!Array.isArray(value) && localValue.length < 1 && Array.isArray(defaultValue)) {
      setLocalValue(defaultValue);
    } else {
      setLocalValue(value || []);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [defaultValue, value]);
  useEffect(function () {
    setDefaultTranslations(translations);
  }, [setDefaultTranslations]);
  return /*#__PURE__*/React.createElement(CheckboxGroupContainer, {
    "data-testid": dataTestId
  }, useCheckAll && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Checkbox, {
    "data-testid": "check-all",
    disabled: disabled,
    checked: isAllChecked,
    indeterminate: localValue.length > 0 && !isAllChecked,
    onChange: function onChange() {
      return handleChange(isAllChecked ? [] : options.map(function (opt) {
        return opt === null || opt === void 0 ? void 0 : opt.value;
      }));
    }
  }, translate(isAllChecked ? 'common:uncheck_all' : 'common:check_all')), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: '10px 0'
    }
  })), /*#__PURE__*/React.createElement(AntCheckboxGroup, {
    direction: direction,
    disabled: disabled,
    name: name,
    options: options,
    value: localValue,
    defaultValue: defaultValue,
    onChange: handleChange
  }, children));
}

export default CheckboxGroup;